import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { requestStatusLoading } from '../../utils/requestStatusUtils';
import useFetchPerformanceData from '../../hooks/useFetchPerformanceData';
import { useContentDetailsDataProvider } from '../../providers/ContentDetailsDataProvider';
import getAnalyticsPageId from '../../utils/contentObjectUtils';
import ReportingFilters from './ReportingFilters';
import { getContentStatusType, useAuthInfoProvider } from 'content-management-data-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PerformanceSection = ({
  children,
  renderEmptyState,
  additionalReportingFilters,
  analyticsPageId,
  currentDateRange,
  currentFrequency,
  onDateRangeChange,
  onFrequencyChange
}) => {
  const {
    contentObject
  } = useContentDetailsDataProvider();
  const analyticsId = analyticsPageId || getAnalyticsPageId(contentObject);
  const {
    hasNoPerformanceData,
    performanceDataRequestStatus
  } = useFetchPerformanceData(analyticsId);
  const {
    getIsUngatedToUseResolvedStateProperty
  } = useAuthInfoProvider();
  const isUngatedToUseResolvedStateProperty = getIsUngatedToUseResolvedStateProperty();
  if (requestStatusLoading(performanceDataRequestStatus)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 300
    });
  }
  const contentStatus = getContentStatusType(contentObject, isUngatedToUseResolvedStateProperty);
  if (hasNoPerformanceData && (contentStatus === 'draft' || contentStatus === 'published' || contentStatus === 'scheduled')) {
    return renderEmptyState({
      contentObject,
      contentStatus
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ReportingFilters, {
      additionalReportingFilters: additionalReportingFilters,
      currentDateRange: currentDateRange,
      currentFrequency: currentFrequency,
      onDateRangeChange: onDateRangeChange,
      onFrequencyChange: onFrequencyChange
    }), children]
  });
};

/**
 *
 * NOTE: The PerformanceSection component does not work for consumers who are
 * trying to test out the reporting components before the reporting BE is
 * set up for their content type because the empty state will always render.
 * This component allows these consumers to test out the reporting components
 * by skipping the empty state and just rendering whatever charts are passed in
 * as children. **This should only be used for testing.*
 *
 */
export const PerformanceSectionWithoutEmptyState = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ReportingFilters, {}), children]
  });
};
export default PerformanceSection;